import React from 'react';
import CloseSVG from 'Components/Admin/assets/CloseSVG';

const CloseButton = ({ closeToast }) => {
  return (
    <div className="admin-notification__close" onClick={closeToast}>
      <CloseSVG />
    </div>
  );
};

export default CloseButton;
